import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getEarnWallets } from 'services/EarnService'
import { EarnWalletsRequestParams } from '../../types'

export const useEarnWalletsQuery = ({
  currencyCode,
  includeCustomerWallets,
  searchTerm,
  page,
  size,
}: EarnWalletsRequestParams) => {
  return useQuery({
    queryKey: reactQueryKeys.earnWallets({
      currencyCode,
      searchTerm,
      page,
      size,
      includeCustomerWallets,
    }),
    queryFn: () => getEarnWallets({ currencyCode, includeCustomerWallets, searchTerm, page, size }),
    enabled: !!currencyCode,
  })
}
